module.exports = __webpack_public_path__ + "static/media/pos.a938609d.scss";


//////////////////
// WEBPACK FOOTER
// ./src/styles/pos.scss
// module id = 2403
// module chunks = 0